<template>
<div class="container-fluid mt-5">
    <div>
    <card
        class="no-border-card"
        body-classes="px-0 pb-1"
        footer-classes="pb-2"
    >
        <template slot="header">
        <div class="row">
            <div class="col-6">
            <h3 class="mb-0">Facturación</h3>
            </div>
            <div class="col-6 text-right">
            </div>
        </div>
        </template>
        <div>
        <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
            <el-select
            class="select-primary pagination-select"
            v-model="pagination.perPage"
            placeholder="Datos por página"
            >
            <el-option
                class="select-primary"
                v-for="item in pagination.perPageOptions"
                :key="item.value"
                :label="item.descripcion"
                :value="Number(item.value)"
            >
            </el-option>
            </el-select>

            <div>
            <form class="apolo-borde">
                <base-input
                v-model="search"
                type="search"
                append-icon="fas fa-search"
                placeholder="Buscar..."
                clearable
                inputClasses="apolo-borde"
                />
            </form>
            </div>

            <el-select
            class="select-primary pagination-select"
            v-model="status"
            clearable
            >
            <el-option
                class="select-primary"
                label="Todos los boletos"
                value="null"
                selected
            >
            </el-option>
            <el-option
                class="select-primary"
                label="Boletos facturados"
                value="1"
            >
            </el-option>
            <el-option
                class="select-primary"
                label="Boletos sin facturar"
                value="0"
            >
            </el-option>
            </el-select>
        </div>
        <div style="overflow-x: scroll; width: auto;"> 
            <el-table
                class="table-responsive align-items-center table-flush"
                header-row-class-name="thead-light"
                :data="facturas"
                @sort-change="sortChange"
            >
                <div slot="empty" v-if="loading">
                <img src="/img/loading.gif" style="height: 100px; width: 100px" />
                </div>

                <div slot="empty" v-if="facturas">
                Sin datos disponibles
                </div>

                <el-table-column label="#" prop="id" min-width="100px"/>
                <el-table-column label="Nombre completo" prop="nombre_pasajero" min-width="200px"/>
                <el-table-column label="Fecha salida" min-width="180px">
                    <div slot-scope="{ row }">
                    <span v-if="row.fecha_salida">{{row.fecha_salida | moment('DD-MM-YYYY hh:mm')}}</span>
                    <span v-else> </span>
                    </div>
                </el-table-column>
                <el-table-column label="# Corrida" min-width="130px">
                    <div slot-scope="{ row }">
                    <span v-if="row.corrida">{{ row.corrida.id }}</span>
                    <span v-else> </span>
                    </div>
                </el-table-column>
                <el-table-column label="# Sub-Corrida" min-width="150px">
                    <div slot-scope="{ row }">
                    <span v-if="row.corrida">{{ row.subcorrida.id }}</span>
                    <span v-else> </span>
                    </div>
                </el-table-column>
                <el-table-column label="Asiento" min-width="110px">
                    <div slot-scope="{ row }">
                    <span v-if="row.asiento">{{ row.asiento }}</span>
                    <span v-else> </span>
                    </div>
                </el-table-column>
                <el-table-column label="Reserva" min-width="180px">
                    <div slot-scope="{ row }">
                        <span>Sin reserva</span>
                    </div>
                </el-table-column>
                <el-table-column label="Liquidado" min-width="125px">
                    <div slot-scope="{ row }">
                        <span v-if="row.liquidado === 1">SI</span>
                        <span v-else>NO</span>
                    </div>
                </el-table-column>
                <el-table-column label="Abordado" min-width="125px">
                    <div slot-scope="{ row }">
                        <span v-if="row.abordado === 1">SI</span>
                        <span v-else>NO</span>
                    </div>
                </el-table-column>
                <el-table-column label="Facturado" min-width="130px">
                    <div slot-scope="{ row }">
                        <span v-if="row.facturado === 1">SI</span>
                        <span v-else>NO</span>
                    </div>
                </el-table-column>
                <el-table-column align="center" min-width="180px">
                    <div slot-scope="{ row }" class="table-actions">
                        <span v-if="row.facturado === 1 && row.liquidado === 1" class="linkFactura" @click="showGetFactura(row)">Ver factura</span>
                        <span v-if="row.facturado === 0 && row.liquidado === 1" class="linkFactura" @click="showAddFactura(row)">Facturar</span>
                        <!--<span v-if="row.facturado === 0 && row.liquidado === 1 && row.abordado === 0" class="linkFactura" @click="showAddFactura(row)">Abordar y Facturar</span>-->
                        <span v-if="row.facturado === 0 && row.liquidado === 0 && row.abordado === 0"> </span>
                        <span v-if="row.facturado === 0 && row.liquidado === 1 && row.abordado === 0"> </span>
                    </div>
                </el-table-column>
            </el-table>
        </div>
        </div>
        <div
        slot="footer"
        class="col-12 d-flex justify-content-center flex-wrap"
        >
        <base-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
        />
        </div>
    </card>
    </div>
    <!-- MODAL VER FACTURA -->
    <modal :show.sync="showVerFacturaModal" modal-classes="modal-primary">
        <h6 slot="header" class="mb-0 modal-title">Información</h6>
        <form class="new-event--form" @submit.prevent="">
            <p v-if="fecha_facturado != null">Boleto facturado el {{ fecha_facturado | moment('DD-MM-YYYY hh:mm') }}</p>

            <base-button class="hover-apolo" type="default" icon size="md">
                <span class="btn-inner--icon"
                ><i class="fas fa-file-pdf"></i
                ></span>
                <span class="btn-inner--text" @click="downloadFactura('pdf')">Descargar PDF</span>
            </base-button>
            <base-button class="hover-apolo" type="default" icon size="md">
                <span class="btn-inner--icon"
                ><i class="fas fa-file"></i
                ></span>
                <span class="btn-inner--text" @click="downloadFactura('xml')">Descargar XML</span>
            </base-button>
            <input type="hidden" class="new-event--start"/>
            <input type="hidden" class="new-event--end"/>
        </form>

        <template slot="footer">
            <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="closeModal">Cerrar</button>
        </template>
    </modal>
    <!-- MODAL FACTURAR -->
    <modal :show.sync="showFacturarModal" modal-classes="modal-primary">
        <h6 slot="header" class="mb-0 modal-title">Confirmar datos de facturación</h6>
        <form class="new-event--form" @submit.prevent="">
            <base-input label="Seleccione un regimen fiscal" v-if="regimenes != null">
                <multiselect v-model="factura.regimen_fiscal" :options="regimenes" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Selecccione Régimen Fiscal" label="regimen_fiscal" track-by="id" :showLabels="false"></multiselect>
            </base-input>
            <validation-error :errors="apiValidationErrors.regimen_fiscal" />
            <base-input label="RFC"
                        placeholder="RFC"
                        v-model="factura.rfc"
                        input-classes="form-control-alternative new-event--title">
            </base-input>
            <validation-error :errors="apiValidationErrors.rfc" />
            <base-input label="Razón social"
                        placeholder="Razón social"
                        v-model="factura.razon_social"
                        input-classes="form-control-alternative new-event--title">
            </base-input>
            <validation-error :errors="apiValidationErrors.razon_social" />
            <base-input label="Código postal"
                        placeholder="Código postal"
                        v-model="factura.cp"
                        input-classes="form-control-alternative new-event--title">
            </base-input>
            <validation-error :errors="apiValidationErrors.cp" />
            <base-input label="Correo donde enviar factura"
                        placeholder="Correo donde enviar factura"
                        v-model="factura.email"
                        input-classes="form-control-alternative new-event--title">
            </base-input>
            <validation-error :errors="apiValidationErrors.email" />
            <span>Opcionales:</span>
            <base-input label="Correo adicional donde enviar factura"
                        placeholder="Correo adicional donde enviar factura"
                        v-model="factura.email_adicional"
                        input-classes="form-control-alternative new-event--title">
            </base-input>
            <validation-error :errors="apiValidationErrors.email_adicional" />
            <base-input label="Calle"
                        placeholder="Calle"
                        v-model="factura.calle"
                        input-classes="form-control-alternative new-event--title">
            </base-input>
            <validation-error :errors="apiValidationErrors.calle" />
            <base-input label="Número"
                        placeholder="Número"
                        v-model="factura.numero"
                        input-classes="form-control-alternative new-event--title">
            </base-input>
            <validation-error :errors="apiValidationErrors.numero" />
            <base-input label="Colonia"
                        placeholder="Colonia"
                        v-model="factura.colonia"
                        input-classes="form-control-alternative new-event--title">
            </base-input>
            <validation-error :errors="apiValidationErrors.colonia" />
            <base-input label="Estado"
                        placeholder="Estado"
                        v-model="factura.estado"
                        input-classes="form-control-alternative new-event--title">
            </base-input>
            <validation-error :errors="apiValidationErrors.estado" />
            <base-input label="Ciudad"
                        placeholder="Ciudad"
                        v-model="factura.ciudad"
                        input-classes="form-control-alternative new-event--title">
            </base-input>
            <validation-error :errors="apiValidationErrors.ciudad" />
            <input type="hidden" class="new-event--start"/>
            <input type="hidden" class="new-event--end"/>
        </form>

        <template slot="footer">
            <button type="submit" class="btn btn-default hover-apolo new-event--add" @click="addFactura()">Aceptar</button>
            <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="closeModal">Cerrar</button>
        </template>
    </modal>
</div>
</template>
<script>
import Multiselect from 'vue-multiselect';
import formMixin from "@/mixins/form-mixin";
import ValidationError from "@/components/ValidationError.vue";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import { BasePagination, Modal, BaseSwitch } from "@/components/";
import {
Table,
TableColumn,
DropdownMenu,
DropdownItem,
Dropdown,
Tooltip,
Select,
Option,
RadioButton,
Button,
} from "element-ui";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import { throws } from 'assert';

export default {
layout: "DashboardLayout",

components: {
    ValidationError,
    Modal,
    Multiselect,
    DatePicker,
    BaseSwitch,
    BasePagination,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
},

mixins: [formMixin],

data() {
    return {
    facturas: [],
    selectedRows: [],

    status: null,
    search: null,

    sort: "created_at",

    pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [{value:'5', descripcion: '5 facturas por página'},
        {value:'10', descripcion: '10 facturas por página'},
        {value:'25', descripcion: '25 facturas por página'},
        {value:'50', descripcion: '50 facturas por página'}],
    },
    total: 0,
    loading: true,
    showVerFacturaModal: false,
    showFacturarModal: false,
    factura: {
        type: "facturación",
        regimen_fiscal: null,
        regimen_fiscal_key: null,
        regimen_fiscal_id: null,
        rfc: null,
        razon_social: null,
        cp: null,
        email: null,
        email_adicional: null,
        calle: null,
        numero: null,
        colonia: null,
        estado: null,
        ciudad: null,
        boleto_id: null
    },
    regimenes: null,
    cliente: null,
    boleto_id: null,
    fecha_facturado: null
    };
},

computed: {
    from() {
    return this.pagination.perPage * (this.pagination.currentPage - 1);
    },

    to() {
    let highBound = this.from + this.pagination.perPage;
    if (this.total < highBound) {
        highBound = this.total;
    }
    return highBound;
    },
},

watch: {
    search: {
    handler: "getListDebounced",
    immediate: true,
    },
    externo: {
    handler: "getListDebounced",
    immediate: true,
    },
    status: {
    handler: "getListDebounced",
    immediate: true,
    },
    pagination: {
    handler: "getList",
    immediate: false,
    deep: true,
    },
    'factura.rfc':{
        handler: "checkRFC",
        immediate: false
    },
},

created(){
    
},

mounted(){
    this.getRegimenes();
},

methods: {
    getListDebounced: _.debounce(function () {
        this.getList();
    }, 300),

    async getList() {
        let params = {
            ...(this.sort ? { sort: this.sort } : {}),
            filter: {
            ...(this.search ? { search: this.search } : {}),
            ...(this.status ? { status: this.status } : {}),
            },
            page: {
                number: this.pagination.currentPage,
                size: this.pagination.perPage,
            },
        };
        await this.$store.dispatch("facturas/list", params).then(() => {
            this.facturas = this.$store.getters["facturas/list"];
            this.total = this.$store.getters["facturas/listTotal"];
        });
        this.loading = false;
    },

    async getRegimenes() {
      await this.$store.dispatch("facturas/getRegimenes").then(() => {
        this.regimenes = this.$store.getters["facturas/getRegimenes"];
      });
    },

    closeModal() {
        if(this.showVerFacturaModal == true){
            this.showVerFacturaModal = false;
        }else{
            this.showFacturarModal = false;
        }
        this.resetApiValidation();
        this.factura.regimen_fiscal = null;
        this.factura.regimen_fiscal_key = null;
        this.factura.regimen_fiscal_id = null;
        this.factura.rfc = null;
        this.factura.razon_social = null;
        this.factura.cp = null;
        this.factura.email = null;
        this.factura.email_adicional = null;
        this.factura.calle = null;
        this.factura.numero = null;
        this.factura.colonia = null;
        this.factura.estado = null;
        this.factura.ciudad = null;
        this.factura.boleto_id = null;
    },

    showAddFactura(row){
        this.factura.boleto_id = row.id;
        //this.factura.abordado = row.abordado;
        this.showFacturarModal = true;
    },

    async addFactura(){
        if(this.factura.regimen_fiscal_key === null){
            this.factura.regimen_fiscal_key = this.factura.regimen_fiscal.clave;
            this.factura.regimen_fiscal_id = this.factura.regimen_fiscal.id;
        }
        try {
        await this.$store.dispatch("facturas/add", this.factura);
        this.$notify({
            type: "success",
            message: "Factura creada satisfactoriamente.",
            duration: -1
        });
        this.getList();
        this.closeModal();
        } catch (error) {
            if(error.response.data.message != undefined){
                this.$notify({
                    type: "danger",
                    message: error.response.data.message +': '+error.response.data.error_details,
                    duration: -1
                });
            }
            if(error.response.data.errors != undefined){
                this.$notify({
                    type: "danger",
                    message: error.response.data.errors[0].detail,
                    duration: -1
                });
                this.resetApiValidation();
                this.setApiValidation(error.response.data.errors);
            }
        }
    },

    async getCliente(rfc){
        await this.$store.dispatch("facturas/getCliente", rfc).then(() => {
            this.cliente = this.$store.getters["facturas/getCliente"];
            this.factura.regimen_fiscal = this.regimenes.filter(item => item.id == this.cliente.regimen_fiscal_id);
            this.factura.regimen_fiscal_key = this.factura.regimen_fiscal[0].clave;
            this.factura.regimen_fiscal_id = this.factura.regimen_fiscal[0].id;
            this.factura.razon_social = this.cliente.razon_social;
            this.factura.cp = this.cliente.cp;
            this.factura.email = this.cliente.email;
            this.factura.email_adicional = this.cliente.email_adicional;
            this.factura.calle = this.cliente.calle;
            this.factura.numero = this.cliente.numero;
            this.factura.colonia = this.cliente.colonia;
            this.factura.estado = this.cliente.estado;
            this.factura.ciudad = this.cliente.ciudad;
        });
    },

    checkRFC(){
        if(this.factura.rfc === null){ return; }; 
        if(this.factura.rfc.length >= 10){
            this.getCliente(this.factura.rfc);
        }else{
            return;
        }
    },

    showGetFactura(row){
        this.boleto_id = row.id;
        this.fecha_facturado = row.fecha_facturado;
        this.showVerFacturaModal = true;
    },

    async downloadFactura(type){
        let factura = [];
        factura.type = type;
        factura.boleto_id = this.boleto_id;
        await this.$store.dispatch("facturas/getFactura", factura).then(() => {
           
        });
    },

    sortChange({ prop, order }) {
        if (order === "descending") {
            this.sort = `-${prop}`;
        } else {
            this.sort = `${prop}`;
        }
        this.getList();
    },
},
};
</script>
<style>
.linkFactura{
    color: blue;
    cursor: pointer;
}
</style>